<pace-forms-list [notificationIdentifier]="notificationIdentifier" [useFormListCache]="useFormListCache">
    <button
        class="btn btn-primary d-none d-lg-inline"
        (click)="downloadAllForms(false)"
        [disabled]="disableDownloadAll$ | async"
        translate="SELECT_FORM_DOWNLOAD_ALL_FORMS"
    ></button>
    <button
        class="btn btn-primary d-none d-lg-inline"
        [disabled]="disableDownloadAll$ | async"
        (click)="downloadAllForms(true)"
        translate="SELECT_FORM_PREVIEW_ALL_FORMS"
    ></button>
    <div class="btn-group-lg d-flex gap-2 d-lg-none" dropdown [dropup]="true">
        <button
            class="btn btn-lg btn-primary"
            (click)="downloadAllForms(false)"
            [disabled]="disableDownloadAll$ | async"
            translate="SELECT_FORM_DOWNLOAD_ALL_FORMS"
        ></button>
        <button
            id="button-overflow-menu"
            dropdownToggle
            type="button"
            class="btn btn-secondary"
            aria-controls="button-overflow-menu"
            [attr.aria-label]="'SELECT_FORM_MENU' | translate"
        >
            <span><fa-icon [icon]="faEllipsisV"></fa-icon> </span>
        </button>
        <ul
            id="button-overflow-content"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-end d-flex flex-column gap-2"
            role="menu"
            aria-labelledby="button-overflow-content"
        >
            <li role="menuitem">
                <button
                    class="dropdown-item btn-lg"
                    [disabled]="disableDownloadAll$ | async"
                    (click)="downloadAllForms(true)"
                    translate="SELECT_FORM_PREVIEW_ALL_FORMS"
                ></button>
            </li>
        </ul>
    </div>
</pace-forms-list>
